/** Chapters in the student's words: runs as ranges, and a shouted heading at reading case. */

/** [1, 2, 3, 7, 9, 10] → "1–3, 7, 9–10"; a run of two stays a list. */
export function chapterSpan(numbers: number[]): string {
  const runs: number[][] = [];
  for (const n of [...new Set(numbers)].sort((a, b) => a - b)) {
    const run = runs[runs.length - 1];
    if (run && run[run.length - 1] === n - 1) run.push(n);
    else runs.push([n]);
  }
  const parts = runs.flatMap((r) =>
    r.length >= 3 ? [`${r[0]}–${r[r.length - 1]}`] : r.map(String),
  );
  return parts.join(", ");
}

/** "chapter 7" or "chapters 1–20". */
export function chaptersLabel(numbers: number[]): string {
  return `${numbers.length === 1 ? "chapter" : "chapters"} ${chapterSpan(numbers)}`;
}

/**
 * A title detected from an all-caps heading ("DATA STORAGE AND COMPRESSION") is set in sentence
 * case; a title with any lower case is the book's own and is left alone.
 */
export function chapterTitle(title: string): string {
  const t = title.trim();
  if (!/[A-Z]/.test(t) || /[a-z]/.test(t)) return t;
  const lower = t.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}
